import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ArrowUpDown } from "lucide-react";
import api from "../lib/api";
import { withCache } from "../lib/offlineStore";
import { useAuth } from "../context/AuthContext";
import { STATUS_META } from "../components/StatusBadge";
import { Button } from "../components/ui/button";

export default function VueCarriere() {
  const { selectedSite } = useAuth();
  const [fronts, setFronts] = useState([]);
  const [sort, setSort] = useState("priority");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    withCache(`fronts_${sort}_${selectedSite}`, () => api.get(`/fronts?sort=${sort}&site=${selectedSite}`).then((r) => r.data))
      .then(({ data }) => setFronts(data))
      .catch(() => setFronts([]))
      .finally(() => setLoading(false));
  }, [sort, selectedSite]);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-cyan-500 mb-1">Vue d'ensemble</div>
          <h1 className="text-3xl font-black uppercase tracking-tight text-slate-50">Vue carrière</h1>
        </div>
        <div className="flex gap-2">
          <Button
            data-testid="sort-priority-button"
            variant={sort === "priority" ? "default" : "outline"}
            onClick={() => setSort("priority")}
            className={sort === "priority" ? "bg-cyan-500 text-black hover:bg-cyan-400" : "border-slate-700 text-slate-300"}
          >
            <ArrowUpDown className="w-4 h-4 mr-1.5" /> Priorité
          </Button>
          <Button
            data-testid="sort-geo-button"
            variant={sort === "geo" ? "default" : "outline"}
            onClick={() => setSort("geo")}
            className={sort === "geo" ? "bg-cyan-500 text-black hover:bg-cyan-400" : "border-slate-700 text-slate-300"}
          >
            Ordre géographique
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="text-slate-500 font-mono text-sm uppercase">Chargement...</div>
      ) : (
        <div className="space-y-2.5" data-testid="vue-carriere-list">
          {fronts.map((f) => {
            const status = f.etat?.Statut_Global || "AUTORISEE";
            const meta = STATUS_META[status];
            const Icon = meta.icon;
            return (
              <Link
                key={f.Front_ID}
                to={`/front/${f.Front_ID}`}
                data-testid={`vue-carriere-row-${f.Front_ID}`}
                className={`flex items-center justify-between gap-4 rounded-xl border-2 ${meta.border} ${meta.solidBg} px-5 py-4 hover:-translate-x-0.5 transition-transform`}
              >
                <div className="flex items-center gap-4">
                  <div className={`w-9 h-9 rounded-full flex items-center justify-center border ${meta.badge}`}>
                    <Icon className="w-4.5 h-4.5" />
                  </div>
                  <div>
                    <div className="font-bold text-slate-100">{f.Front_Libelle}</div>
                    <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">{f.Front_ID}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-xs font-bold uppercase tracking-wide ${meta.badge.split(" ").find(c => c.startsWith("text-"))}`}>
                    {meta.emoji} {meta.short}
                  </span>
                  <ChevronRight className="w-5 h-5 text-slate-500" />
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
